import {
  CompanyAboutTabEnum,
  CompanyGovernanceTabEnum,
  CompanyLiquidityTabEnum,
  CompanyOperatingSegmentsTabEnum,
  CompanyFinancialsTabEnum,
  CompanyQuotesTabEnum,
  CompanyEventsTabEnum,
  CompanyDiscussionsTabEnum,
  CompanyAssetsTabEnum,
  CompanyHighlightsTabEnum,
} from "components/company/v3/menu/enums";

export function getAmplitudeTabContentInfo(tab: string) {
  switch (tab) {
    case CompanyAboutTabEnum.ABOUT:
      return {
        section: "Sobre",
        tab: "Sobre",
      };

    case CompanyAboutTabEnum.HISTORY:
      return {
        section: "Sobre",
        tab: "Histórico",
      };

    case CompanyAboutTabEnum.RISK_FACTORS:
      return {
        section: "Sobre",
        tab: "Fatores de Risco",
      };

    case CompanyAboutTabEnum.COMPENSATION_POLICY:
      return {
        section: "Sobre",
        tab: "Política de Remuneração",
      };

    case CompanyAboutTabEnum.SUBSIDIARIES:
      return {
        section: "Sobre",
        tab: "Subsidiárias",
      };

    case CompanyGovernanceTabEnum.EQUITY_POSITION:
      return {
        section: "Governança",
        tab: "Posição Acionária",
      };

    case CompanyGovernanceTabEnum.EXECUTIVE:
      return {
        section: "Governança",
        tab: "Executivos",
      };

    case CompanyGovernanceTabEnum.COMPENSATION:
      return {
        section: "Governança",
        tab: "Remuneração",
      };

    case CompanyGovernanceTabEnum.EMPLOYEES:
      return {
        section: "Governança",
        tab: "Funcionários",
      };

    case CompanyGovernanceTabEnum.RECLAME_AQUI:
      return {
        section: "Governança",
        tab: "Reclame Aqui",
      };

    case CompanyGovernanceTabEnum.FREE_FLOAT:
      return {
        section: "Governança",
        tab: "Free Float",
      };

    case CompanyLiquidityTabEnum.TRADE_HISTORY:
      return {
        section: "Liquidez",
        tab: "Histórico de Negociação",
      };

    case CompanyLiquidityTabEnum.SHARES_OUTSTANDING:
      return {
        section: "Liquidez",
        tab: "Ações em Circulação",
      };

    case CompanyLiquidityTabEnum.FREE_FLOAT:
      return {
        section: "Liquidez",
        tab: "Free Float",
      };

    case CompanyLiquidityTabEnum.SHARES_HOLDERS:
      return {
        section: "Liquidez",
        tab: "Acionistas",
      };

    case CompanyOperatingSegmentsTabEnum.BUSINESS:
      return {
        section: "Segmentos Operacionais",
        tab: "Negócios",
      };

    case CompanyOperatingSegmentsTabEnum.GEOGRAPHIC:
      return {
        section: "Segmentos Operacionais",
        tab: "Geográfico",
      };

    case CompanyFinancialsTabEnum.FINANCIALS:
      return {
        section: "Financeiros",
        tab: "Tabela Fundamentalista",
      };

    case CompanyFinancialsTabEnum.FINANCIALS_CHART:
      return {
        section: "Financeiros",
        tab: "Gráficos Fundamentalistas",
      };

    case CompanyFinancialsTabEnum.COMPARE:
      return {
        section: "Financeiros",
        tab: "Comparativo",
      };

    case CompanyFinancialsTabEnum.KPIS:
      return {
        section: "Financeiros",
        tab: "KPIs",
      };

    case CompanyQuotesTabEnum.QUOTE:
      return {
        section: "Cotações",
        tab: "Cotação",
      };

    case CompanyQuotesTabEnum.HISTORICAL_RETURN:
      return {
        section: "Cotações",
        tab: "Retorno Histórico",
      };

    case CompanyQuotesTabEnum.PRICE_VS_INDICATOR:
      return {
        section: "Cotações",
        tab: "Preço vs Indicador",
      };

    case CompanyQuotesTabEnum.MARKET_CAPITALIZATION:
      return {
        section: "Cotações",
        tab: "Valor de Mercado",
      };

    case CompanyEventsTabEnum.RELEASES:
      return {
        section: "Eventos",
        tab: "Comunicados",
      };

    case CompanyEventsTabEnum.CALENDAR:
      return {
        section: "Eventos",
        tab: "Calendário",
      };

    case CompanyEventsTabEnum.DIVIDENDS:
      return {
        section: "Eventos",
        tab: "Dividendos",
      };

    case CompanyEventsTabEnum.STOCK_DIVIDENDS:
      return {
        section: "Eventos",
        tab: "Dividendos de Ações",
      };

    case CompanyEventsTabEnum.RIGHTS_ISSUES:
      return {
        section: "Eventos",
        tab: "Subscrição",
      };

    case CompanyEventsTabEnum.STOCK_SPLIT:
      return {
        section: "Eventos",
        tab: "Desdobramento de Ações",
      };

    case CompanyDiscussionsTabEnum.COMMENTS:
      return {
        section: "Discussões",
        tab: "Comentários",
      };

    case CompanyDiscussionsTabEnum.FAQ:
      return {
        section: "Discussões",
        tab: "FAQ",
      };

    case CompanyAssetsTabEnum.DISTRIBUTION:
      return {
        section: "Ativos",
        tab: "Distribuição",
      };

    case CompanyAssetsTabEnum.QUOTA:
      return {
        section: "Ativos",
        tab: "Ativos",
      };

    case CompanyHighlightsTabEnum.HIGHLIGHTS:
      return {
        section: "Destaques",
        tab: "Destaques Financeiros",
      };

    case CompanyHighlightsTabEnum.VIDEOS:
      return {
        section: "Destaques",
        tab: "Vídeo",
      };

    default:
      throw new Error(`The tab "${tab}" does not exist in the mapping of tabs for amplitude`);
  }
}
